module.exports = __webpack_public_path__ + "static/img/layout-img-main@t.9f52c60.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/layout-img-main@t.png
// module id = 3j58
// module chunks = 0